module.exports = __webpack_public_path__ + "static/media/empty.f2c348f9.svg";